import { useLanguage } from "../i18n/LanguageContext";
import { SEOHead } from "../components/SEOHead";
import { PageHeader } from "../components/PageHeader";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { MapPlaceholder } from "../components/home/LocationSection";
import { nearbyGroups } from "../config/nearby";
import { ContactCTA } from "../components/home/ContactCTA";
import { ICON_3D, Icon3D } from "../components/Icon3D";

const audienceIcons = [ICON_3D.hardhat, ICON_3D.briefcase, ICON_3D.users];

export default function Location() {
  const { t, tr } = useLanguage();
  return (
    <main data-testid="location-page">
      <SEOHead title={t.meta.location.title} description={t.meta.location.description} />
      <PageHeader eyebrow={t.locationPage.eyebrow} title={t.locationPage.title} text={t.locationPage.text} crumb={t.nav.location} testId="location-header" />

      <section className="container-x">
        <Reveal><MapPlaceholder className="aspect-[16/9] md:aspect-[21/9]" /></Reveal>
      </section>

      <section className="container-x section">
        <Reveal><h2 className="h3">{t.locationPage.audienceTitle}</h2></Reveal>
        <Stagger className="mt-8 grid gap-4 md:grid-cols-3">
          {t.locationPage.audiences.map((a, i) => (
            <StaggerItem key={a.title} className="card group p-7">
              <Icon3D src={audienceIcons[i]} />
              <h3 className="mt-5 font-display text-xl font-medium">{a.title}</h3>
              <p className="mt-2 text-sm text-charcoal-500 leading-relaxed">{a.text}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <section className="container-x section !pt-0">
        <Reveal>
          <div className="max-w-2xl">
            <h2 className="h3">{t.locationPage.detailsTitle}</h2>
            <p className="mt-3 text-charcoal-500">{t.locationPage.detailsText}</p>
          </div>
        </Reveal>
        <Stagger className="mt-12 grid gap-x-10 gap-y-12 md:grid-cols-2 lg:grid-cols-3" >
          {nearbyGroups.map((g) => {
            return (
              <StaggerItem key={g.icon} className="group" data-testid={`nearby-group-${g.icon}`}>
                <div className="flex items-center gap-3">
                  <Icon3D src={ICON_3D[g.icon] ?? ICON_3D.Landmark} size="xs" />
                  <h3 className="font-display text-lg font-medium">{tr(g.title)}</h3>
                </div>
                <ul className="mt-4 border-t border-sand-200">
                  {g.items.map((it) => (
                    <li key={it.name} className="flex items-baseline justify-between gap-4 border-b border-sand-200 py-2.5">
                      <span className="text-sm text-charcoal-700">{it.name}</span>
                      <span className="shrink-0 whitespace-nowrap text-sm tabular-nums text-charcoal-400">{it.distance}</span>
                    </li>
                  ))}
                </ul>
              </StaggerItem>
            );
          })}
        </Stagger>
        <Reveal>
          <p className="mt-8 text-xs text-charcoal-400">{t.locationPage.detailsNote}</p>
        </Reveal>
      </section>

      <ContactCTA />
    </main>
  );
}
